import attr from 'ember-data/attr';
import SegmentModel from 'cio/models/segment';

export default class CustomerSegmentModel extends SegmentModel {
  @attr('number') timestamp!: number;

  // Override releationships, so that Ember Data doesn't complain about
  // polymorphic relationships
  @attr() audienceIds!: string[];
  @attr() audiences!: any;
  @attr() createdByUser!: any;
  @attr() updatedByUser!: any;
  @attr() tagIds!: string[];
  @attr() tags!: any;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'customer-segment': CustomerSegmentModel;
  }
}
